import { render, staticRenderFns } from "./ColumnManagementBtn.vue?vue&type=template&id=fe2d4d90&scoped=true&"
import script from "./ColumnManagementBtn.vue?vue&type=script&lang=js&"
export * from "./ColumnManagementBtn.vue?vue&type=script&lang=js&"
import style0 from "./ColumnManagementBtn.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ColumnManagementBtn.vue?vue&type=style&index=1&id=fe2d4d90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2d4d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe2d4d90')) {
      api.createRecord('fe2d4d90', component.options)
    } else {
      api.reload('fe2d4d90', component.options)
    }
    module.hot.accept("./ColumnManagementBtn.vue?vue&type=template&id=fe2d4d90&scoped=true&", function () {
      api.rerender('fe2d4d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/Table/ColumnManagementBtn.vue"
export default component.exports